/* ============================================================
   NORTHSHEEP — when to open the basket after "Add to basket"
   (owner, 2026-09-15)

   Dawn slides the basket drawer open after EVERY add. With one or two pieces
   that is a useful confirmation; for someone adding five sheepskins in a row
   it is a drawer across the page five times.

   Theme settings → Northsheep cart → "Open the basket after adding":
     first  (default) — open the drawer when
              - it is the first add in this visit, or
              - the basket was empty (a basket emptied and started again is
                a new first add), or
              - this add unlocks free shipping (worth showing);
            every other add updates the drawer in the background, bumps the
            basket count, and shows a small note: "Added to your basket ·
            View basket".
     always — Dawn's behaviour: open on every add.

   Called from product-form.js (window.nsBasketOpen.render). Never throws into
   the add flow: anything unexpected falls back to opening the drawer, which is
   what the shop did before.
   ============================================================ */
(function () {
  'use strict';

  if (window.nsBasketOpen) return;

  var KEY = 'northsheep_basket_opened';
  var cfg = window.nsBasketOpenSettings || {};

  function sessionGet() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function sessionSet() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function basketWasEmpty(drawer) {
    return drawer.classList.contains('is-empty') || !drawer.querySelector('.cart-item');
  }

  /* Free shipping just unlocked: before the add the drawer still carried the
     "amount to go" panel (data-ns-remaining); the freshly rendered drawer no
     longer does, and shows the free-shipping line instead. */
  function unlocksFreeShipping(drawer, response) {
    var html = response && response.sections && response.sections['cart-drawer'];
    if (!html || !drawer.querySelector('[data-ns-remaining]')) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return !doc.querySelector('[data-ns-remaining]') && !!doc.querySelector('[data-ns-free-shipping]');
  }

  function shouldOpen(drawer, response) {
    if (cfg.mode === 'always') return true;
    var open = !sessionGet() || basketWasEmpty(drawer) || unlocksFreeShipping(drawer, response);
    if (open) sessionSet();
    return open;
  }

  /* CartDrawer.renderContents without the open() at the end. */
  function renderQuietly(drawer, response) {
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.productId = response.id;
    drawer.getSectionsToRender().forEach(function (section) {
      var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      var html = response.sections && response.sections[section.id];
      if (!el || !html) return;
      el.innerHTML = drawer.getSectionInnerHTML(html, section.selector);
    });
    drawer.classList.remove('is-empty');
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  // ---- The note ----
  var toastEl = null, toastTimer = 0;

  function strings() { return window.nsBasketToastStrings || {}; }

  function hideToast() {
    window.clearTimeout(toastTimer);
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function showToast(drawer, response) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ns-basket-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<span class="ns-basket-toast__media" aria-hidden="true"></span>' +
        '<span class="ns-basket-toast__text"></span>' +
        '<button type="button" class="ns-basket-toast__view"></button>' +
        '<button type="button" class="ns-basket-toast__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>';
      document.body.appendChild(toastEl);
      toastEl.addEventListener('mouseenter', function () { window.clearTimeout(toastTimer); });
      toastEl.addEventListener('mouseleave', function () { toastTimer = window.setTimeout(hideToast, 2500); });
      toastEl.querySelector('.ns-basket-toast__close').addEventListener('click', hideToast);
      toastEl.querySelector('.ns-basket-toast__view').addEventListener('click', function (e) {
        hideToast();
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') d.open(e.currentTarget);
      });
    }
    var s = strings();
    toastEl.querySelector('.ns-basket-toast__text').textContent = s.added || 'Added to your basket';
    toastEl.querySelector('.ns-basket-toast__view').textContent = s.view || 'View basket';
    toastEl.querySelector('.ns-basket-toast__close').setAttribute('aria-label', s.close || 'Close');
    var media = toastEl.querySelector('.ns-basket-toast__media');
    media.innerHTML = '';
    if (response && response.image) {
      var img = document.createElement('img');
      img.alt = '';
      img.width = 40;
      img.height = 40;
      img.src = response.image + (response.image.indexOf('?') === -1 ? '?' : '&') + 'width=80';
      media.appendChild(img);
    }
    media.hidden = !(response && response.image);
    window.clearTimeout(toastTimer);
    // Next frame, so a toast already on screen replays its entrance.
    toastEl.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    toastTimer = window.setTimeout(hideToast, 4500);
  }

  function render(drawer, response) {
    try {
      if (shouldOpen(drawer, response)) {
        hideToast();
        drawer.renderContents(response);
        return;
      }
      renderQuietly(drawer, response);
      /* ON A PHONE THE HEADER ANSWERS INSTEAD OF A NOTE (owner, 20 Sep 2026:
         "instead can you let the floating header come down and then put small
         animation or something that the cart count or favourite count
         changed").

         The rule above is untouched: the FIRST add of a visit still opens the
         whole drawer, as does an add that empties into a new basket or unlocks
         free shipping. This is only what happens for every add after that —
         the floating header comes down, the basket count counts up, and it
         leaves again. The shopper can tap it to open the drawer, which is what
         the note's "View basket" was for.

         flash() returns false on a desktop, where there is no floating header
         to bring down; there the note appears exactly as before. */
      if (!(window.NsFloatHeader && NsFloatHeader.flash && NsFloatHeader.flash('cart'))) {
        showToast(drawer, response);
      }
    } catch (e) {
      drawer.renderContents(response);
    }
  }

  window.nsBasketOpen = { render: render };

  // Opening the drawer any other way (the basket icon) retires the note.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) hideToast();
  });
})();
